// app colors
export const colors = {
  black: '#000',
  white: '#fff',
  orange: '#f16602',
  yellow: '#f4cb0e',
};

export const oranges = {
  orange500: '#db692f',
  orange400: '#df7325',
};

// gray shaded
export const grays = {
  gray100: '#f1f1f1',
  gray800: '#323232',
  gray500: '#5a5a5b',
  gray200: '#e8e8e8',
};

// blue shades
export const blues = {
  blue800: '#232750',
  blue100: '#e2efec',
};

const yellows = {
  yellow: '#fea555',
};

// all colors
export const appColors = {
  ...colors,
  ...grays,
  ...blues,
  ...oranges,
  ...yellows,
};

export const fontFamily = {
  poppins: 'Poppins, sans-serif',
  fredoka: 'Fredoka one, sans-serif',
};

export const fontWeight = {
  light: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  bolder: 800,
  black: 900,
};

// breakpoints
export const breakpoints = {
  xs: {
    down: '0px',
    up: '0px',
  },
  sm: {
    down: '575px',
    up: '576px',
  },
  md: {
    down: '767px',
    up: '768px',
  },
  lg: {
    down: '991px',
    up: '992px',
  },
  xl: {
    down: '1299px',
    up: '1200px',
  },
  xxl: {
    down: '1399px',
    up: '1400px',
  },
};
